import jsondiffpatch from 'jsondiffpatch/public/build/jsondiffpatch';
import _ from 'lodash';

export default angular
  .module(
    'doxy.realtime.components.teleconsent.action.share.paged.teleconsent-share.AuditTrialService',
    []
  )
  .factory('AuditTrailService', function ($log, $filter) {
    class AuditTrailService {
      constructor(data) {
        this.receivedData = undefined;
        this.receivedDiff = undefined;
        this.document = data.document;
        this.me = data.me;
        this.innerMediator = data.innerMediator;
        
        // Ensure innerMediator is available before setting up event listeners
        if (this.innerMediator && typeof this.innerMediator.on === 'function') {
          this.innerMediator.on('data:get', this.onDataGet.bind(this));
        } else {
          console.warn('AuditTrailService: innerMediator not available or missing on method');
        }
      }

      watch(newVal, oldVal) {
        if (_.isEqual(newVal, this.receivedData)) return;
        var diff = jsondiffpatch.diff(oldVal, newVal);
        if (
          !diff ||
          (this.receivedDiff && angular.equals(diff, this.receivedDiff))
        )
          return;
        this.innerMediator.emit('data', diff);
        this.setAuditTrial(diff);
      }

      onDataGet(dataDiff, person) {
        this.receivedDiff = dataDiff;
        const oldData = _.cloneDeep(this.document.data);
        jsondiffpatch.patch(this.document.data, dataDiff);
        if (_.isEqual(oldData, this.document.data)) return;
        this.receivedData = _.cloneDeep(this.document.data);
        this.setAuditTrial(dataDiff, person, true);
      }

      setAuditTrial(diff, person) {
        // Ensure this.me is available before accessing its properties
        if (!this.me || this.me.type !== 'r') return; //no need to track as a patient
        
        this.document.auditTrial = this.document.auditTrial || {};
        Object.keys(diff).forEach((key) => {
          var field = this.document.metadata.fields[key];
          if (!field)
            $log.error('setAuditTrial', {
              action: 'setAuditTrial',
              message: 'Missing field in metadata',
              key: key,
            });
          if (!field || !field.audit) return;
          
          // Ensure this.me properties are available
          const username = this.me.username || 'Unknown';
          const ip = this.me.privateData && this.me.privateData.ip ? this.me.privateData.ip : 'Unknown';
          
          this.document.auditTrial[key] = {
            time: $filter('date')(new Date(), 'medium'),
            fieldName: this.document.metadata.fields[key].name,
            role: person ? 'Participant' : 'Researcher',
            editedBy: person ? (person.state && person.state.username ? person.state.username : 'Unknown') : username,
            ip: person ? (person.state && person.state.privateData && person.state.privateData.ip ? person.state.privateData.ip : 'Unknown') : ip,
          };
        });
      }
    }

    return AuditTrailService;
  }).name;
